import { render, staticRenderFns } from "./EmployeeEditor.vue?vue&type=template&id=4c04ca84&scoped=true&"
import script from "./EmployeeEditor.vue?vue&type=script&lang=js&"
export * from "./EmployeeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c04ca84",
  null
  
)

export default component.exports